import { IconButton } from '../icon-button'
import { Icon } from '../icon'
import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { restartScenario, selectReferrerUrl, selectScenarioIsWaitingForAnswer, useDispatch } from '../../state'
import { clearScenarioCookie } from '../../scenarios'
import { LoadingNewAnswer } from '../spinners/loading-new-answer'

export const ScenarioCancel = () => {
  const dispatch = useDispatch()
  const referrerUrl = useSelector(selectReferrerUrl)
  const scenarioIsWaitingForAnswer = useSelector(selectScenarioIsWaitingForAnswer)

  const restart = useCallback(() => {
    dispatch(restartScenario())
  }, [dispatch])

  const redirectToWebsite = () => {
    clearScenarioCookie()
    window.location.assign(referrerUrl as string)
  }

  const closeIcon = scenarioIsWaitingForAnswer ? (
    <LoadingNewAnswer />
  ) : (
    <IconButton label="Close" size="3xl" icon={<Icon icon="close" color="green.500" />} onClick={redirectToWebsite} />
  )
  const restartIcon = (
    <IconButton label="Restart" size="2xl" onClick={() => restart()} icon={<Icon icon="reload" color="green.500" />} />
  )

  return referrerUrl ? closeIcon : restartIcon
}
